



























































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from "@/lib/abpbase"

@Component
export default class XX extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean;
	@Prop({type: Object, default: {}}) data: any;
	patient: any = {}
	item: any = {}

	created() {
		this.patient = this.data.patient
		this.item = this.data.item
	}

	cancel() {
		this.$emit('input', false);
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/summaryDetail.vue